import * as React from 'react';
import { Popover } from 'antd';
import { CronData, DataQuery } from '@interface/index';
import { isEqual } from '@lib/index';
import { BodyGroup, NiSelect, NiInput, CronNode, HelperPopover } from '@component/index';
import { localizedString } from '@locale/index';
import { isValidCron } from 'cron-validator';
import '@style/component/cron/index.less';

interface CronDataCompProps {
  disabled?: boolean;
  data?: CronData;
  dataQueryOptions: DataQuery[];
  onChange: (data: CronData) => void;
}

interface CronDataCompState {
  dataQueryId: string;
  schedule: string;
}

export class CronDataComp extends React.Component<CronDataCompProps, CronDataCompState> {

  state = {
    dataQueryId: '',
    schedule: '',
    diffVisible: false
  };

  componentDidMount() {
    this.onInit();
  }

  componentDidUpdate(prevProps: CronDataCompProps) {
    if (!isEqual(prevProps.data, this.props.data)) {
      this.onInit();
    }
  }

  render() {
    const { disabled, dataQueryOptions, data } = this.props;
    const { dataQueryId, schedule } = this.state;

    const scheduleValid = isValidCron(schedule);

    return (
      <BodyGroup
        title="Cron"
        titleExtra={
          <HelperPopover text={localizedString('cron_popover', {
            learnMore: <a href="https://www.ostechnix.com/a-beginners-guide-to-cron-jobs/" target="_blank">
              learn more
            </a>,
            here: <a href="https://crontab.guru/" target="_blank">
              here
            </a>
          })} />
        }
        extra={[]}
      >
        <div className="cron-row" key="data-query">
          <span className="label">Contact</span>
          <NiSelect
            disabled={disabled}
            value={dataQueryId.length ? dataQueryId : undefined}
            onChange={(value: string) => {
              this.setState({
                dataQueryId: value
              }, this.handleChange);
            }}
            placeholder={localizedString('cron_function_slot_placeholder')}
          >
            {dataQueryOptions.map((dq: DataQuery) => {
              return (
                <NiSelect.Option key={dq.id} value={String(dq.id)}>
                  {dq.name}
                </NiSelect.Option>
              );
            })}
          </NiSelect>
        </div>
        <div className="cron-row" key="schedule">
          <span className="label">Schedule</span>
          <NiInput
            disabled={disabled}
            value={schedule}
            placeholder={localizedString('cron_schedule_placeholder')}
            onChange={(e: any) => {
              const nextValue = e.target.value;
              this.setState({
                schedule: nextValue
              });
            }}
            onBlur={this.handleChange}
            onPressEnter={this.handleChange}
          />
        </div>
        {
          schedule.length && !scheduleValid &&
          <span className="schedule-err">Invalid schedule!</span> || ''
        }
      </BodyGroup >
    );
  }

  onInit = () => {
    const { data } = this.props;
    this.setState({
      dataQueryId: data && data.dataQueryId || '',
      schedule: data && data.schedule || ''
    });
  };

  handleChange = () => {
    const { dataQueryId, schedule } = this.state;

    const nextData = {
      dataQueryId,
      schedule
    };

    this.props.onChange(nextData);
  };
}
